import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

export class BaseApiClient {
    constructor(
        private http: HttpClient,
    ) {
    }

    get<T>(url: string,
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> },
    ): Observable<T> {
        return this.http.get<T>(url, {
            headers: this.getHeaders(),
            params: params,
        });
    }

    post<T>(url: string, body?: any): Observable<T> {
        return this.http.post<T>(url, body, {
            headers: this.getHeaders(),
        });
    }

    patch<T>(url: string, body: any): Observable<T> {
        return this.http.patch<T>(url, body, {
            headers: this.getHeaders(),
        });
    }

    delete<T>(url: string): Observable<T> {
        return this.http.delete<T>(url, {
            headers: this.getHeaders(),
        });
    }

    getHeaders(): { [key: string]: string } {
        return Object.assign({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }, this.getAdditionalHeaders())
    }

    getAdditionalHeaders(): { [key: string]: string } {
        return {}
    }
}
